import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Search from "./Search";
import Footer from "./Footer";
import MobileBottomNav from "./MobileBottomNav";
import { Toaster } from "react-hot-toast";
import ScrollToTop from "../pages/shared/ScrollTop";
import LoginModal from "../pages/login";

const Layout = ({ children }) => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const { pathname } = useLocation();
  const hideMobileNav = pathname === "/cart" || pathname === "/checkout";

  useEffect(() => {
    window.showLoginModal = () => setShowLoginModal(true);
    return () => delete window.showLoginModal;
  }, []);

  return (
    <>
      <ScrollToTop />
      <Search />
      
      <div className="layout-with-mobile-nav">
        {children}
        <Footer />
      </div>
      <Toaster position="top-center" />
      {!hideMobileNav && <MobileBottomNav />}
      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
      />
    </>
  );
};

export default Layout;
